import { Icon, type IconGlyphProps } from 'BomdisoftComponents/icons/base';
import { INFO_OUTLINED_GLYPH } from 'BomdisoftComponents/icons/glyphs';

export const InfoOutlinedIcon = (props: IconGlyphProps) => <Icon {...props} glyph={INFO_OUTLINED_GLYPH} />;
